export default {
  // Options.jsx
  items_per_page: '/ ڵاپەرە',
  jump_to: 'بڕو بۆ',
  jump_to_confirm: 'پشت راستکردنەوە',
  page: 'ڵاپەرە',

  // Pagination.jsx
  prev_page: 'ڵاپەرەی پێشو',
  next_page: 'ڵاپەرەی داهاتو',
  prev_5: '۵ ڵاپەرەی پێشو',
  next_5: '۵ ڵاپەرەی داهاتو',
  prev_3: '۳ ڵاپەرەی پێشو',
  next_3: '۳ ڵاپەرەی داهاتو',
};
